var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/chevron-rdown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 66",
    d: "M14 5L8 11L2 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 3.8637
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon_chevron_down.008898b41edbceb0ee7d0cf0c8b622f1.svg";
export { ForwardRef as ReactComponent };